import React, {Component} from "react";
import { FormGroup, FormControl} from "react-bootstrap";
import "./login.scss";
import headerLogo from './../../../assets/new-logo.svg';
import {Helmet} from "react-helmet";
import {toast} from 'react-toastify';
import { Divider, Message, Modal,Button,  Accordion, Icon } from 'semantic-ui-react';
import CookieDisclaimer from 'react-cookie-disclaimer';

import {AuthService} from "../../../services/auth-service";
import { Link, withRouter } from 'react-router-dom';
import {env, version, apiUrl} from "../../../config"
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios'; 
import * as api from '../../../api';


class Login extends Component {

    
    constructor(props) {
        super(props);
        this.authService = new AuthService();

        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            email: "",
            password: "",
            failedAttempts: 0,  // Track failed login attempts
            showRecaptcha: false,  // Determine whether to show reCAPTCHA
            isReset: false,  // Add this to track if the password needs to be reset
            showPolicyModal: false,
            policyPDFUrl: '',
            acceptPolicyEnabled: false
        };
    }

    validateForm() {
        return this.state.email.length > 0 && this.state.password.length > 0;
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    notifyParent = (authData) => {
  
        this.props.onUserAuthenticated(true, authData.token);
    }

    handleRecaptchaChange = (value) => {
        // You can use the value here for server-side verification later if needed
        // For now, just reset failed attempts and hide the reCAPTCHA after successful interaction
        this.setState({
            failedAttempts: 0,
            showRecaptcha: false
        });
    }
    
    fetchPolicyPDF = async (documentID) => {
        this.setState({ downloadingFile: true });
    
        axios({
            url: `${apiUrl}/Documents/DownloadDocument/${documentID}`,
            method: 'POST',
            headers: {
                'Authorization': `bearer ${localStorage.getItem("token")}`
            },
            responseType: 'blob', // Important for handling the file stream
        }).then((response) => {
            this.setState({ downloadingFile: false });
    
            const pdfUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            this.setState({ policyPDFUrl: pdfUrl, showPolicyModal: true });
        }).catch((error) => {
            this.setState({ downloadingFile: false });
            console.error("Error fetching policy PDF", error);
            // Handle error appropriately
        });
    }

    updateUserPolicyRead = async (username) => {
    
        Promise.all([
            api.updateUserPolicyReadAccepted()
        ])
        .then(([res]) => {

            this.props.history.push("/");
            window.location.reload();
        })
    }
    
    
    

    handleAcceptPolicy = () => {
        // Logic for accepting the policy
        this.setState({ showPolicyModal: false });

        //Update user to has read = true
        this.updateUserPolicyRead();
    
    }

    handleRejectPolicy = () => {
        // Logic for rejecting the policy
        this.setState({ showPolicyModal: false });
        // Logout logic here
        this.authService.clearUserCache();

        this.props.history.push("/logout");
        window.location.reload();
    }

    handleSubmit = (event) => {
        event.preventDefault();
    
        this.authService
            .authenticateUser(this.state.email, this.state.password)
            .then((response) => {
                // Assuming the response has a property 'isReset' you can check
                if (response.isExpired) {
                    // Handle the reset scenario
                    this.setState({ isReset: true }); // You would add `isExpired` to your state
                    // ... Other actions like redirecting to reset password page or displaying a message
                } else {

                    if (response.latestPortalPolicyAccepted === false) {
                        if(true)//response.currentPolicyID === 0) //<<--Policy work configed off for now
                        {
                            this.authService.cacheUserData(response);
                            this.notifyParent(response);
                        }else
                        {
                        this.authService.cacheUserData(response);

                        this.fetchPolicyPDF(response.currentPolicyID); // Replace 52 with actual document ID
                        }
                    } else {

                    this.authService.cacheUserData(response);
                    this.notifyParent(response);
                    }
                }
            })
            .catch((error) => {
                let failedAttempts = this.state.failedAttempts + 1;
                this.setState({
                    failedAttempts: failedAttempts,
                    showRecaptcha: failedAttempts >= 3  // Show reCAPTCHA after 3 failed attempts
                });
                
                toast.error(error.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    delay: 2000
                });
            });
    }
    
    renderPolicyModal = () => {
    const { showPolicyModal, policyPDFUrl, acceptPolicyEnabled } = this.state;

    return (
        <Modal open={showPolicyModal} size="large">
            <Modal.Header>Policy Agreement</Modal.Header>
            <Modal.Content>
                <Message info>
                    <Message.Header>Attention Required</Message.Header>
                    <p>
                        To access the Inenco portal, you must review and accept our latest user policy. Please expand the policy below and read it thoroughly before proceeding.
                    </p>
                </Message>
                <Accordion>
                    <Accordion.Title
                        active={acceptPolicyEnabled}
                        onClick={() => this.setState({ acceptPolicyEnabled: !acceptPolicyEnabled })}
                    >
                        <Icon name='dropdown' />
                        View Latest User Policy
                    </Accordion.Title>
                    <Accordion.Content active={acceptPolicyEnabled}>
                        <iframe
                            id="policy-iframe"
                            title="Policy"
                            src={policyPDFUrl}
                            style={{ width: '100%', height: '60vh' }} // Adjust height as needed
                        />
                    </Accordion.Content>
                </Accordion>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    positive
                    content="Accept & Continue"
                    onClick={this.handleAcceptPolicy}
                    disabled={!acceptPolicyEnabled}
                />
                <Button
                    color="red"
                    onClick={this.handleRejectPolicy}
                >
                    Reject & Logout
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

    

    render() {
        return (
            <div>
            <div className="login">

                <Helmet>
                    <title>Inenco Portal | Log In</title>
                </Helmet>

                <img src={headerLogo} alt="header-logo" id="login-logo"/>

                <form onSubmit={this.handleSubmit}>
                    <FormGroup controlId="email">
                        <FormControl
                            autoFocus
                            type="email"
                            value={this.state.email}
                            onChange={this.handleChange}
                            placeholder="E-mail address"
                            className="username"
                        />
                    </FormGroup>
                    <FormGroup controlId="password">
                        <FormControl
                            value={this.state.password}
                            onChange={this.handleChange}
                            type="password"
                            className="password"
                            placeholder="Password"
                        />
                    </FormGroup>
                    {this.state.isReset && (
                      <Message info>
                      <Message.Header>Password Reset Required</Message.Header>
                      <p>
                          Your password has expired. Please set up a new password using the instructions sent to your email.
                      </p>
                  </Message>
                )}
                    {!this.state.showRecaptcha ? (
    <Button
        block
        fluid
        active
        disabled={!this.validateForm()}
        type="submit"
        color='facebook' >
        Login
    </Button>
) : (
    <ReCAPTCHA
        sitekey="6LcelccoAAAAAJIh2sgVzZNXJmAgKmXzSC8GszfT"
        onChange={this.handleRecaptchaChange}
    />
)}


                  

                </form>
                 
                <div className="reset-link-div">
                    <Link to="/password-reset" id="forgot-password">
                        Forgot password?
                    </Link>

                    <Divider section> </Divider>

                    <Link to="/logindomain" id="login-domain">
                        Internal User Login 
                    </Link>
                    <Divider section> </Divider>
                    <Link  to={{pathname: "/"
                            }} onClick={() => {
                                this.authService.updateSSOLogin(true)
                                window.location.reload();
                            }}  id="sso">Customer SSO</Link>


                   
                    <div className="bottom aligned content">
                        <div className="header">
                            <a href="https://www.inenco.com/wp-content/uploads/2021/11/Privacy-Policy-Nov.-2021.pdf" title="Inenco privacy policy" rel="noopener noreferrer" target="_blank" className="link-text">Privacy Policy</a>
                        </div>
                    </div>
                   
                </div>
                <div className="version-details">
                    Version: {env} | {version}
                </div>
               
{this.renderPolicyModal()}
            </div>
             <div className="cookie-disclaimer-container">
             <CookieDisclaimer 
   background='#636363' 
   bottomPosition={true}
   closeIconSize={30}
   closeIconPositionTop={false}
   color='#fff'
   cookiePolicyName='Cookie Policy'
   cookiePolicyLink='/CookiePolicy' 
   cookiePolicyText='By continuing to use the service, you agree to our Privacy policy and '
   text='This website uses cookies to improve service.'
 />
</div>
</div>

            
        );
    }
}

export default withRouter(Login);
